<template>
    <div class="modal-box" v-show="showVideoModal" >
        <div class="modal-header-title">视频播放</div>
        <div class="modal-close" @click="handleCloseVideo">x</div>
        <div class="modal-content">
            <div class="video-pane">
        <video id="videoModalId" :src="videoUrl" controls v-if="showVideoModal" autoplay></video>
        </div>
        <div >
          <a-button class="modal-button" type="text" danger :disabled="!currentDevice?.current?.children?.status" @click="currentDevice?.current?.children?.status && changeVideo(currentDevice)">
            <SwapOutlined/>
            <span>{{ isDock ? '云台直播' : '机场直播' }}</span>
          </a-button>
        </div>
        </div>
         <div class="modal-footer">
            <div class="modal-info">
                <div class="modal-info-item">电池:{{ deviceStatusInfo?.device?.battery?.capacity_percent ?
                                deviceStatusInfo?.device?.battery?.capacity_percent + ' %' :
                                str }}</div>
                <div class="modal-info-item">飞行速度:{{
                                deviceStatusInfo?.device?.horizontal_speed
                               ?deviceStatusInfo?.device?.horizontal_speed.toFixed(2) + ' m/s':'--' }}</div>
                <div class="modal-info-item">飞行高度:{{ deviceStatusInfo?.device?.elevation ?
                                deviceStatusInfo.device.elevation.toFixed(2) + ' m':'--' }}</div>
                <div class="modal-info-item">状态:{{ deviceStatusInfo?.device?EDockModeCodeMap[deviceStatusInfo?.device?.mode_code as EDockModeCode]:EDockModeCodeMap[EDockModeCode.Disconnected] }}</div>
                <div class="modal-info-item">当前控制:--</div>
            </div>
        </div>
</div>
</template>
<script lang="ts" setup>
import { watch, reactive } from 'vue'
import { useMyStore } from '/@/store'
import { EDockModeCodeMap, EDockModeCode } from '/@/types/device'
import { showVideoModal, videoUrl, handleCloseVideo, currentDevice, isDock, changeVideo } from '/@/hooks/Cesium'
import { EDeviceTypeName } from '/@/types'

const store = useMyStore()
const str = '--'
const deviceStatusInfo = reactive({
  device: null
})

watch(() => store.state.deviceState, data => {
  if (currentDevice.value.current) {
    if (data.currentType === EDeviceTypeName.Dock && data.dockInfo[currentDevice.value.current.device_sn || currentDevice.value.current.sn]) {
      deviceStatusInfo.device = data.deviceInfo[currentDevice.value.current.device_sn || currentDevice.value.current.sn]
    }
  }
}, {
  deep: true,
  immediate: true,
})
</script>

<style lang="scss" scoped>
.modal-box {
  position: fixed;
  top: 28%;
  left: 40%;
  z-index: 1000;
  width: 500px;
  background-color: #0615369f;
  border-radius: 8px;
  overflow: hidden;

  .modal-close {
    position: absolute;
    top: 0;
    right: 0;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #fff;
    cursor: pointer;
    z-index: 10;
    &:hover{
      color: #007bff;
    }
  }

  .modal-header-title{
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
  }

  .modal-content{
    width: 100%;
    height: calc(100% - 100px);
  }

  .modal-button {
    cursor: pointer;
    margin-left: 75%;
    transition: opacity 0.3s;
    user-select: none; /* 防止双击选中文本 */
    margin-top: 10px;

    // 新增禁用样式
    &:disabled,&:disabled:hover {
      opacity: 0.5;       /* 透明度降低 */
      color: #8fb4ff; // 或者 #ccc，让文字也变灰，视觉更明显
      cursor: not-allowed !important;
      // pointer-events: none; /* 彻底禁用鼠标事件（双重保险） */
    }
  }

  .modal-footer {
    width: 100%;
    padding: 15px 0;

    .modal-info {
      display: flex;
      flex-wrap: wrap;
      color: #fff;
      padding: 0 16px;
      row-gap: 12px;

      .modal-info-item {
        width: 33.33%;
        min-height: 44px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 8px;
        box-sizing: border-box;

        .info-label {
          color: #8fb4ff;
          font-size: 12px;
          margin-bottom: 4px;
          line-height: 1.2;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .info-value {
          font-size: 14px;
          font-weight: 500;
          color: #ffffff;
          line-height: 1.3;
          word-break: break-all;
        }
      }
    }
  }
}

.video-pane{
  width: 100%;
  height: 300px;
  #videoModalId{
    width: 100%;
    height: 100%;
  }
}
</style>
